<template>
  
  <data-section
    style="font-size: 15px"
    theme="green"
    title="國泰人壽保單"
    :datas="datas"
    :_fields="dataFields"
    @toggle="
      (isShow) => $router.assignQuery({ CathayLifeInsuranceShow: isShow })
    "
    :initShow="$route.query['CathayLifeInsuranceShow'] !== 'false'"
  >
    <template scope="props" v-if="refresh">
     <!--<button
        v-if="isSelectable"
        type="button"
        class="btn btn-default btn-sm m-0 mt-2"
        @click="clearSelectedProduct"
      >
        清空所有保單
      </button>--> 
      <section
        v-for="(person, index) in props.datas.filter((x) =>
          allFamily.includes(x.insuredpersonid)
        )"
        :key="'other' + index"
        class="newTable"
      >
        <data-table
          :isSelectable="isSelectable"
          class="mt-2"
          v-bind="
            Object.assign({}, props, {
              datas: proccessDatas(person),
            })
          "
          @changeSort="
            (sort) =>
              $router.assignQuery({
                [`CathayLifeInsuranceSort${index}`]: JSON.stringify(sort),
              })
          "
          :initSort="
            $route.query[`CathayLifeInsuranceSort${index}`]
              ? JSON.parse($route.query[`CathayLifeInsuranceSort${index}`])
              : null
          "
        >
          <template slot="thead">
            <thead class="thBorderCust" style="background-color: white">
              <tr>
                <th
                class="thBorderCust"
                style="
                    border: #53c480 1px solid;
                    background-color: rgb(250, 250, 225);
                    "
                :colspan="isSelectable ? 10 : 9"
                >
                  <div class="font-20 text-center text-black position-relative">
                    <span v-if="isSelectable" class="checkbox m-0 select-all">
                      <input
                        type="checkbox"
                        :id="`customer${person.insuredpersonid}`"
                        :value="person.insuredpersonid"
                        v-model="checkAllList"
                        @change="checkAll(person)"
                      />
                      <label :for="`customer${person.insuredpersonid}`">全選</label>
                    </span>
                    <strong>
                      {{ headerLabel }}：
                      <avatar
                        class="mr-2 mt-1"
                        :gender="
                          Number(person.insuredpersonsex == 'Female' ? 2 : 1)
                        "
                        :size="20"
                      />
                    </strong>
                    <!-- 20210624 個資遮蔽 -->
                    <Tooltip
                      position="top"
                      :id="
                        person.insuredpersonid &&
                        !person.insuredpersonid.includes('~')
                          ? person.insuredpersonid
                          : ''
                      "
                      :birthday="
                        person.insuredpersonbirthday
                          ? person.insuredpersonbirthday
                          : ''
                      "
                      style="font-size: 16px; font-weight: 500"
                    >
                      <strong
                        @click="
                          routeToCustDetail(
                            person.insuredpersonid,
                            person.insuredpersonname
                          )
                        "
                        class="link text-underline"
                        style="font-size: 20px"
                      >
                        {{ person.insuredpersonname | truncate }}
                      </strong>
                    </Tooltip>
                    <strong class="ml-3">年齡：</strong>
                    <span class="fw-normal">
                      {{
                        person.age
                          ? person.age
                          : person.insuredpersonbirthday
                          ? moment().diff(person.insuredpersonbirthday, "years")
                          : "一一"
                      }}歲 ({{
                        person.insuredpersonbirthday
                          ? moment(person.insuredpersonbirthday).getROCDate()
                          : "一一" | getMaskBirthday
                      }})
                    </span>
                    <strong class="ml-3">身分證：</strong>
                    <span class="fw-normal">
                      {{
                        person.insuredpersonid.includes("~")
                          ? "一一"
                          : person.insuredpersonid | getMaskID
                      }}
                    </span>
                  </div>
                </th>
              </tr>
            </thead>
          </template>
          <template slot="productselect" scope="item">
            <span 
              v-if="item.data.isPrimaryContract || item.data.isPureSubContract" 
              class="checkbox m-0"
            >
              <input
                type="checkbox"
                :id="getProductLabelId(item)"
                :value="getProductLabelId(item)"
                v-model="checkedList"
                @change="checkProduct"
              />
              <label :for="getProductLabelId(item)"></label>
            </span>
          </template>
          <template slot="productname" scope="item">
            <div v-if="item.data.isPrimaryContract">
              <div
                class="font-13"
                :class="
                  item.data.b015plcno ? 'policyBlue' : 'link text-underline'
                "
                @click="selectInventInsurance(item.data)"
              >
                {{ item.data.policynumber }}
                <div
                  :class="{ 'section-loading': modalLoading }"
                  class="d-inline-block"
                  style="height: 20px; width: 30px"
                ></div>
              </div>
              <div>{{ item.data.productname }}({{ item.data.prodid }})</div>
              <div v-if="item.data.ceplcvl">
                <span style="color: #ffa500">
                  保單價值:
                  {{ item.data.money == "NTD" ? "" : item.data.money }}
                  {{ Number(item.data.ceplcvl) | numberFormat3 }}
                </span>
              </div>
              <div v-if="item.data.cepremamt">
                <span style="color: #ffa500"
                  >已墊繳本金：{{
                    Number(item.data.cepremamt) | numberFormat
                  }}元</span
                >
              </div>
            </div>
            <div v-else-if="item.data.isPureSubContract">
              <div>
                <div class="font-13">
                  <label class="text-bold text-gray">純附約</label>
                </div>
                <div
                  class="font-13"
                  :class="{ policyBlue: item.data.b015plcno }"
                >
                  <label>{{ `${item.data.policynumber}` }}</label>
                </div>
                {{ item.data.productname
                }}{{ item.data.prodid ? `(${item.data.prodid})` : "" }}
              </div>
              <div style="color: #ffa500" v-if="item.data.cerdjobc_nm">
                職業類別：{{ item.data.cerdjobc_nm }}
              </div>
            </div>
            <div v-else>
              <div style="margin-left: 1em; text-indent: -1em">
                <span style="text-shadow: 0px 1px grey" class="text-gray">
                  <strong>└</strong>
                </span>
                <span
                  >{{ item.data.productname
                  }}{{ item.data.prodid ? `(${item.data.prodid})` : "" }}</span
                >
              </div>
              <div
                style="color: #ffa500; margin-left: 1em"
                v-if="item.data.cerdjobc_nm"
              >
                職業類別：{{ item.data.cerdjobc_nm }}
              </div>
            </div>
          </template>
          <template slot="applicant" scope="item">
            <span
              v-if="item.data.apcid != ''"
              @click="routeToCustDetail(item.data.apcid, item.data.applicant)"
              class="link text-underline"
            >
              {{ item.data.applicant | truncate }}
            </span>
          </template>
          <template slot="year" scope="item">
            {{
              item.data.paymentway == "躉繳"
                ? "--"
                : item.data.year.padLeft(2, "0")
            }}
          </template>
          <template slot="amountofinsurance" scope="item">
            <div
              v-if="item.data.schemename && item.data.quantity"
              class="text-right pre-formatted"
            >
              {{ `計畫${item.data.schemename}：` }}
              {{
                item.data.schemename && item.data.schemename.includes("_1")
                  ? ``
                  : `日額`
              }}
              {{ `${item.data.quantity}元` }}
            </div>
            <div v-else class="text-right">
              {{ item.data.amountofinsurance }}
            </div>
          </template>
          <template slot="bknm" scope="item">
            <div v-if="item.data.premium">
              {{ item.data.money }} {{ item.data.premium | numberFormat }}
            </div>
            <div>
              {{
                `${item.data.paymentway}${
                  item.data.paymenttype ? `/${item.data.paymenttype}` : ""
                }`
              }}
            </div>
            <div v-if="item.data.bknm || item.data.card_acnt_no">
              {{ `${item.data.bknm}(${item.data.card_acnt_no})` }}
            </div>
          </template>
          <template slot="bnf" scope="item">
            <div
              v-if="item.data.cebnfkd && item.data.cebnfkd.length != 0 
              && item.data.cebnfnm && item.data.cebnfnm.length != 0 "
              :set="(names = item.data.cebnfkd)"
            >
              <div v-for="(key, index) in names" :key="index">
                {{ translate.cebnfkd[key] }}:
                <truncate-tool
                  :content="item.data.cebnfnm[index].trim()"
                ></truncate-tool>
                {{
                  (Math.round(item.data.rato[index]) == 0 ||
                  Math.round(item.data.rato[index]) == 100
                    ? ""
                    : Math.round(item.data.rato[index]) + "%") +
                  (Math.round(
                    item.data["ceseq"] ? item.data["ceseq"][index] : 0
                  ) == 0
                    ? ""
                    : Math.round(item.data["ceseq"][index]))
                }}
                {{ item.data.totalcount[index] }}
              </div>
            </div>
            <div v-else>一一</div>
          </template>
          <template slot="isprimarycontract" scope="item">
            <div>
              {{ getCepremamt(item.data.infcd, item.data.isprimarycontract) }}
            </div>
            <div>
              <span
                v-if="item.data.med_exam == '2' && item.data.isprimarycontract"
                :style="{
                  'font-size': '15px',
                  color: '#f58818',
                }"
                >(弱體件)</span
              >
            </div>
          </template>
        </data-table>
      </section>
    </template>
  </data-section>
</template>

<script>
import InsuranceMixins from "./Insurance";
import TruncateTool from "./TruncateTool";
import Tooltip from "@/desktop/components/ToolTip";

const { moment } = window;
export default {
  mixins: [InsuranceMixins],
  components: {
    TruncateTool,
    Tooltip,
  },
  //20251103要保人視角
    props: {
    reportView: {
      type: String,
      default: 'insured'
    },
    selectInventInsurance: {
      type: Function,
      default: () => {
        return null;
      },
    },
    modalLoading: {
      type: Boolean,
      default: false,
    },
    isSelectable: {
      type: Boolean,
      default: false,
    },
    isSelectAll: {
      type: Boolean,
      default: false,
    },
    selectedProduct: {
      type: Array,
      default: () => {
          return []
      }
    },
  },
  //20250731全選功能
  watch: {
    selectedProduct: {
      handler(newVal) {
        if (!this.isInternalUpdate && newVal !== this.checkedList) {
          this.checkedList = Array.isArray(newVal) ? [...newVal] : [];
          this.checkAllList = this.getCheckAllList();
        }
      },
      deep: true,
      immediate: false  // 改為 false，避免初始化時的衝突
    },
    isSelectAll(val) {
      if (val) {
        this.datas.filter((x) => this.allFamily.includes(x.insuredpersonid)).forEach(person => {
          person.majorpolicyinfolist.forEach(element => {
            const value = person.insuredpersonid + "_" + element.policynumber;
            if (!this.checkedList.includes(value)) {
              this.checkedList.push(value);
            }
          });
        });
      } else {
        this.checkedList = [];
      }
      this.checkAllList = this.getCheckAllList();
      this.$emit('update', this.checkedList, this.checkAllList);
    },
  },
  /*props: {
    selectInventInsurance: {
      type: Function,
      default: () => {
        return null;
      },
    },
    modalLoading: {
      type: Boolean,
      default: false,
    },
    isSelectable: {
      type: Boolean,
      default: false,
    },
    isSelectAll: {
      type: Boolean,
      default: false,
    },
    selectedProduct: {
      type: Array,
      default: () => {
          return []
      }
    },
  },*/
  data() {
    return {
      allFamily: localStorage.allFamily.split(","),
      checkedList: [],
      checkAllList: [],
      checkCount: {},
      isInternalUpdate: false
    };
  },
  computed: {
    // 20251103要保人視角
    headerLabel() {
      return this.reportView === 'applicant' ? '要保人' : '被保人';
    },
    relationLabel() {
      return this.reportView === 'applicant' ? '被保人' : '要保人';
    },    
    dataFields() {
      const result = this.isSelectable ? [
        {
          name: '保單\n選擇',
          key: 'productselect',
          width: 50,
          sortable: false,
          orderByMultiKey: ['sortProductname'],
          thClassName: 'text-center',
          className: 'text-center',
        },
      ] : [];
      return result.concat([
        {
          name: '保單號碼\n險種',
          key: 'productname',
          width: 153,
          sortable: true,
          orderByMultiKey: ['sortProductname'],
          orderByMultiType: ['asc'],
        },
        {
          name: this.relationLabel,
          key: 'applicant',
          width: 79,
          sortable: true,
          orderByMultiKey: ['sortApplicant'],
          orderByMultiType: ['asc'],
        },
        { name: '繳費\n年期', key: 'year', width: 55, className: 'text-left' },
        {
          name: '承保\n對象',
          key: 'relation',
          width: 53,
          thClassName: 'text-left',
          className: 'text-left',
        },
        {
          name: '投保始期',
          key: 'insurancedate',
          width: 95,
          className: 'text-left',
          sortable: true,
          orderByMultiKey: ['sortInsuranceADDate'],
          orderByMultiType: ['asc'],
        },
        {
          name: '保額',
          key: 'amountofinsurance',
          width: 96,
          thClassName: 'text-right',
          className: 'text-right',
        },
        {
          name: '下期應繳保費\n繳別/繳費方式',
          key: 'bknm',
          width: 138,
          thClassName: 'text-right',
          className: 'text-right',
          sortable: true,
          orderByMultiKey: ['sortBknm'],
          orderByMultiType: ['asc'],
        },
        { name: '受益人', key: 'bnf', width: 151 },
        {
          name: '契約狀態',
          key: 'isprimarycontract',
          sortable: true,
          width: 99,
          orderByMultiKey: ['sortIsprimarycontract'],
          orderByMultiType: ['asc'],
        },
      ], this._fields);
    },
  },
  methods: {
    proccessDatas(person) {
      return person.majorpolicyinfolist
        .map((primary) => {
          const primaryData = primary.policyinfolist[0];
          return primary.policyinfolist.map((data) => {
            const isPrimaryContract = !!data.isprimarycontract;
            const isPureSubContract = primary.policyinfolist.every(
              (x) => !x.isprimarycontract
            );
            const isSubContract = !isPrimaryContract && !isPureSubContract;
            return Object.assign({}, data, {
              companyshortname: primary.companyshortname,
              producttype: primary.producttype,
              policynumber: primary.policynumber,
              apcid: primary.apcid,
              applicant: primary.applicant,
              targetId: person.insuredpersonid,
              paymenttype: primary.paymenttype,
              card_acnt_no: primary.card_acnt_no,
              bknm: primary.bknm,
              c111_apc: primary.c111_apc,
              isPrimaryContract,
              isPureSubContract, 
              isSubContract,
              trClassName: isPrimaryContract ? "bg-white" : "bg-gray",
              sortProductname: this.mergeString(primary.policynumber),
              sortApplicant: this.mergeString(
                primary.applicant,
                primary.policynumber
              ),
              sortInsuranceADDate: this.mergeString(
                moment(primaryData.insurancedate).getADDate(),
                primary.policynumber
              ),
              sortBknm: this.mergeString(
                !primaryData.premium ? "" : "_",
                primaryData.money,
                primaryData.premium.padLeft(20, "0"),
                primary.policynumber
              ),
              sortIsprimarycontract: this.mergeString(
                this.getCepremamt(
                  primaryData.infcd,
                  primaryData.isprimarycontract
                ),
                primary.policynumber
              ),
            });
          });
        })
        .flat();
    },
    getProductLabelId(item) {
      if (this.reportView === 'applicant') {
        return item.data.targetId + "_" + item.data.policynumber + "_" + (item.data.apcid || '');
      }      
      return item.data.targetId + "_" + item.data.policynumber
    },
    clearSelectedProduct() {
      this.checkedList = [];
      this.checkAllList = [];
      this.$emit('update', this.checkedList, this.checkAllList);
    },
    syncFromParent(selectedPolicyIds) {
        this.isInternalUpdate = true;
        this.checkedList = [...selectedPolicyIds];
        this.checkAllList = this.getCheckAllList();
        this.$forceUpdate();
        
        this.$nextTick(() => {
            setTimeout(() => {
                this.isInternalUpdate = false;
            }, 50);
        });
    },
    checkAll(person) {
      this.isInternalUpdate = true;  
      
      if(this.checkAllList.includes(person.insuredpersonid)) {
        person.majorpolicyinfolist.forEach(element => {
          const value = this.reportView === 'applicant'
            ? person.insuredpersonid + "_" + element.policynumber + "_" + (element.apcid || '')
            : person.insuredpersonid + "_" + element.policynumber;
            
          if (!this.checkedList.includes(value)) {
            this.checkedList.push(value);
          }
        });
      } else {
        const result = [];
        this.checkedList.forEach(element => {
          if (!element.includes(person.insuredpersonid)) {
            result.push(element);
          }
        });
        this.checkedList = result;
      }
      this.$emit('update', this.checkedList, this.checkAllList);
      this.$nextTick(() => {
        setTimeout(() => {
          this.isInternalUpdate = false;
        }, 50);
      });
    },

    getCheckAllList() {
      const result = [];
      const count = {};
      this.checkedList.forEach(e => {
        const id = e.split("_")[0];
        if (count[id]) count[id]++;
        else count[id] = 1;
      });
      this.datas.filter((x) => !!count[x.insuredpersonid]).forEach(e => {
        count[e.insuredpersonid] 
          && e.majorpolicyinfolist.length == count[e.insuredpersonid]
          && result.push(e.insuredpersonid);
      });
      return result;
    },
    checkProduct() {
      this.isInternalUpdate = true;  
      this.checkAllList = this.getCheckAllList();
      this.$emit('update', this.checkedList, this.checkAllList);
      this.$nextTick(() => {
        setTimeout(() => {
          this.isInternalUpdate = false;
        }, 50);
      });
    }
  },
  mounted() {
    if (this.isSelectable) {
      if (Array.isArray(this.selectedProduct) && this.selectedProduct.length > 0) {
        this.checkedList = [...this.selectedProduct];
        this.checkAllList = this.getCheckAllList();
      }
    }
  },
};
</script>

<style scoped lang="scss">
td {
  .checkbox {
    input + label:before {
      left: -10px
    }
  }
}
.select-all {
  position: absolute;
  left: 0;
  top: 5px;
  font-size: 15px;
  font-weight: normal;
  & > label {
    line-height: 20px !important;
  }
}
</style>
